/**
 * Subscription Plans Repository
 *
 */

import { createRepository } from 'data/utils/createRepository';

const subscriptionPlansRepository = createRepository({
	endpoint: 'subscription-plans',
	name: 'subscriptionPlans',
	statePath: 'subscriptionPlans',
});

export const {
	name,
	statePath,
	thunks: subscriptionPlansThunks,
	reducer: subscriptionPlansReducer,
	actions: subscriptionPlansActions,
	types: subscriptionPlansTypes,
	selectors: subscriptionPlansSelectors,
	useHook: useSubscriptionPlans,
} = subscriptionPlansRepository;

export default subscriptionPlansRepository;
